import React from "react";

import { BarChart, Bar, CartesianGrid, Tooltip, XAxis, YAxis, ResponsiveContainer } from "recharts";

export default class SplitChart extends React.PureComponent {
  render() {
    const { data, option } = this.props;

    if (data === undefined || option === undefined) {
      return <div />;
    }

    return (
      <ResponsiveContainer>
        <BarChart data={data[option.key]}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="Subgroup" />
          <YAxis unit={"%"} domain={[0, 100]} />
          <Tooltip />
          <Bar dataKey={option.label} fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
